import { IAnalyticsEvent } from "@r3f-component-data-structure/types/analytics";

export abstract class AnalyticsProvider {
  protected _COOKIE_PREFIXES: string[] = [];
  constructor(propertyIds?: string[]) {
    if (propertyIds) this.init(propertyIds);
  }

  abstract init (propertyIds: string[]): void 
  abstract updateCookieConsent (granted: boolean): void
  abstract sendEvent(event: IAnalyticsEvent): void
  
  protected _removeCookies(): void {
		this._COOKIE_PREFIXES.forEach((prefix) => {
			const prefixedCookies = document.cookie.split(';').filter((item) => item.trim().startsWith(prefix));
			prefixedCookies.forEach((cookieName) => {
				document.cookie = `${cookieName}=x; max-age=0`;
			});
		});
	}
}